const pageNameKey = "permissionMissing";

export const permissionMissingEn = {
  [pageNameKey]: {
    hintTitle: "Please contact your support team for assistance.",
    title: "You do not have permissions to perform this action",
  },
};

export const permissionMissingPtBr = {
  [pageNameKey]: {
    hintTitle: "Entre em contato com sua equipe de suporte para obter ajuda.",
    title: "Você não tem permissão para realizar esta ação",
  },
};

export const permissionMissingDe = {
  [pageNameKey]: {
    hintTitle:
      "Bitte wenden Sie sich an Ihr Support-Team, um Unterstützung zu erhalten.",
    title:
      "Sie verfügen nicht über ausreichende Berechtigungen, um diese Aktion auszuführen",
  },
};

export const permissionMissingZhHans = {
  [pageNameKey]: {
    hintTitle: "请联系您的支持团队寻求帮助。",
    title: "您没有执行此操作的权限",
  },
};

export const permissionMissingIt = {
  [pageNameKey]: {
    hintTitle: "Contatta il tuo team di supporto per assistenza.",
    title: "Non hai i permessi per eseguire questa azione",
  },
};

export const permissionMissingEs = {
  [pageNameKey]: {
    hintTitle: "Ponte en contacto con tu equipo de soporte para obtener ayuda.",
    title: "No tienes permisos para realizar esta acción",
  },
};

export const permissionMissingNl = {
  [pageNameKey]: {
    hintTitle: "Neem contact op met uw support team voor hulp.",
    title: "U hebt onvoldoende rechten om deze actie uit te voeren",
  },
};

export const permissionMissingTr = {
  [pageNameKey]: {
    hintTitle: "Yardım için lütfen destek ekibinizle iletişime geçin.",
    title: "Bu işlemi gerçekleştirmek için izniniz yok",
  },
};
